import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Category, CategoryCreate, CategoryFilter } from '../data/category';

export function createCategoryService(client: AxiosInstance) {
  return createCrudService<Category, CategoryCreate, CategoryFilter>(client, "/master-data/ProductCategory", "categoryId");
}

export type CategoryService = CrudService<Category, CategoryCreate, CategoryFilter>;
